import { DispatchLockingSystemReducer } from "reducers/lockingSystemReducer"

export const setComponentName = (
	dispatch: DispatchLockingSystemReducer,
	uuid: string,
	name: string,
) => {
	const payload = {
		uuid,
		name,
	}

	dispatch({
		type: "SET_COMPONENT_NAME",
		payload,
	})
}
